import {useState, useMemo} from 'react'
import useTranslation from './use-translation'

/**
 * Custom hook for handling translation of review text.
 *
 * @param {Object} review - The review object to be translated.
 * @returns {Object} - An object containing functions and data related to review translation.
 */
export const useTranslatableReview = (review) => {
    const [isShowTranslated, setIsShowTranslated] = useState(false)
    const reviewLang = useMemo(() => review?.ContentLocale?.split('_')[0], [review?.ContentLocale])
    const reviewTranslation = useTranslation({
        disabled: !isShowTranslated,
        text: review?.ReviewText,
        fromLanguage: reviewLang
    })

    const commentTranslation = useTranslation({
        disabled: !isShowTranslated,
        text: review?.ClientResponses[0]?.Response,
        fromLanguage: reviewLang
    })

    return {
        isTranslationEnabled: reviewTranslation.available,
        setTranslate: setIsShowTranslated,
        reviewTranslation,
        commentTranslation,
        reviewLang,
        isShowTranslated
    }
}
